import {css} from 'styled-components';

import {hoverSelector} from '../../../../../libs/shared/core/src/helpers/browser/hoverHelpers';
import {isDarkTheme} from '../../../../../libs/shared/ui/src/theme/themeTypeHelpers';

export const internalRecipientStyle = css`
  color: ${(p) => p.theme.greys.shade90};
  background-color: ${(p) =>
    isDarkTheme(p.theme) ? p.theme.palette.blue.shade30 : p.theme.palette.blue.shade20};

  ${hoverSelector} {
    background-color: ${(p) =>
      isDarkTheme(p.theme) ? p.theme.palette.blue.shade40 : p.theme.palette.blue.shade30};
  }
`;
